const list = "_086l12f9bia";
const bullet = "_086b1k3czbx";

export { bullet, list };
import "./atom.bullets.style.linaria.module.css";
//# sourceMappingURL=atom.bullets.style.js.map
